"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _ContentView = _interopRequireDefault(require("../../../../../../../../ContentView")),
    _utils = require("../../../../../../../../../utils"),
    _CommentAssets = _interopRequireDefault(require("../../../../../../../../CommentAssets"));

require("../styles/_reply.scss");

var handleDelete = (0, _lodash["default"])(function (_ref) {
  var commentId = _ref.commentId,
      comment = _ref.comment,
      deleteReply = _ref.deleteReply;
  return function () {
    deleteReply({
      commentId: commentId,
      parentComment: comment
    });
  };
}),
    handleReplyToComment = (0, _lodash["default"])(function (_ref2) {
  var userId = _ref2.userId,
      name = _ref2.name,
      replyToComment = _ref2.replyToComment;
  return function () {
    replyToComment({
      userId: userId,
      name: name
    });
  };
}),
    toggleAssets = function toggleAssets(showAssets, setShowAssets) {
  return function () {
    setShowAssets(!showAssets);
  };
};

function Reply(_ref3) {
  var deleteReply = _ref3.deleteReply,
      replyToComment = _ref3.replyToComment,
      createdByUser = _ref3.createdByUser,
      commentId = _ref3.commentId,
      assetIds = _ref3.assetIds,
      content = _ref3.content,
      parentComment = _ref3.parentComment,
      isReadOnly = _ref3.isReadOnly,
      _useState = (0, _react.useState)(!1),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      showAssets = _useState2[0],
      setShowAssets = _useState2[1],
      _getUser = (0, _utils.getUser)(createdByUser),
      userId = _getUser.userId,
      name = _getUser.name,
      isUser = _getUser.isUser,
      imageUrl = _getUser.imageUrl;

  return _react["default"].createElement("div", {
    className: "reply"
  }, _react["default"].createElement("div", {
    className: "reply__user-profile"
  }, _react["default"].createElement(_uiKit.Image, {
    height: "20px",
    width: "20px",
    circular: !0,
    imageUrl: imageUrl,
    placeholderText: name,
    placeholderTextSize: 9,
    backgroundSize: "cover"
  }), _react["default"].createElement("span", null, isUser ? "YOU" : name.toUpperCase())), _react["default"].createElement(_ContentView["default"], {
    content: content
  }), isReadOnly ? null : _react["default"].createElement("div", {
    className: "reply__controls"
  }, isUser ? null : _react["default"].createElement(_uiKit.LinkButton, {
    className: "reply__controls__reply",
    onClick: handleReplyToComment({
      userId: userId,
      name: name,
      replyToComment: replyToComment
    })
  }, "REPLY"), _react["default"].createElement("div", {
    className: "reply__controls__row"
  }, assetIds && 0 < assetIds.length && _react["default"].createElement(_uiKit.LinkButton, {
    className: "reply__controls__assets",
    onClick: toggleAssets(showAssets, setShowAssets)
  }, showAssets ? "Hide" : "Show", " ", "Assets"), isUser ? _react["default"].createElement(_uiKit.Icon, {
    className: "reply__controls__trash-icon",
    "data-testid": "delete-reply-icon",
    onClick: handleDelete({
      deleteReply: deleteReply,
      comment: parentComment,
      commentId: commentId
    }),
    name: "trash",
    color: "russian",
    hoverColor: "black",
    size: 15
  }) : null)), showAssets && _react["default"].createElement("div", {
    className: "assets-wrapper"
  }, _react["default"].createElement(_CommentAssets["default"], {
    assetIds: assetIds,
    commentId: commentId
  })));
}

var _default = (0, _react.memo)(Reply);

exports["default"] = _default;